import { useGetSafeClientCode } from '@/hooks/router'
import { ReactNode } from 'react'

import { useGetClientMarketFundamentals } from '@/gen/marketDataApi'
import { MarketDetailDto } from '@/gen/publicApi'

import Breadcrumbs from '@/containers/breadcrumbs'

import { Badge } from '@/components/badge'
import Content from '@/components/content'
import MarketStateCircle from '@/components/marketStateCircle'
import PageHeader from '@/components/pageHeader'

interface Props {
    market: MarketDetailDto
    children?: ReactNode
}

export default function MarketHeading({ market }: Props) {
    const clientCode = useGetSafeClientCode()
    const marketFundamentals = useGetClientMarketFundamentals(clientCode, market.code)

    let stateCmp: ReactNode = null
    if (market.rowState === 'Deleted') {
        stateCmp = <span className="text-sm font-normal text-destructive">Deleted</span>
    } else if (marketFundamentals?.data) {
        const lastTimingEvent = marketFundamentals.data.lastTimingEvent || 'Open'
        const effectiveState = marketFundamentals.data.effectiveState || 'Open'
        stateCmp = (
            <MarketStateCircle
                state={market.state}
                lastTimingEvent={lastTimingEvent}
                effectiveState={effectiveState}
                className="ml-2"
            />
        )
    }

    return (
        <>
            <Breadcrumbs />
            <Content>
                <PageHeader
                    title={market.name}
                    linkTo="/$client_code/markets/$market_code/"
                    linkParams={{
                        client_code: clientCode,
                        market_code: market.code,
                    }}
                >
                    <Badge className="mx-4" variant="outline">
                        {market.code}
                    </Badge>
                    {stateCmp}
                </PageHeader>
            </Content>
        </>
    )
}
